const religiousSect = [
  { label: "Hanafi", value: "Hanafi" },
  { label: "Shafi'i", value: "Shafi'i" },
  { label: "Maliki", value: "Maliki" },
  { label: "Hanbali", value: "Hanbali" },
  { label: "Salafi", value: "Salafi" },
  { label: "Others", value: "Others" },
];
export default religiousSect;
